import React from 'react';
import './InfoCards.css';

// Icons for the cards
const PlaneIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 16 16">
    <path d="M6.428 1.151C6.708.591 7.213 0 8 0s1.292.592 1.572 1.151C9.861 1.73 10 2.431 10 3v3.691l5.17 2.585a1.5 1.5 0 0 1 .83 1.342V12a.5.5 0 0 1-.582.493l-5.507-.918-.375 2.253 1.318 1.318A.5.5 0 0 1 10.5 16h-5a.5.5 0 0 1-.354-.854l1.319-1.318-.376-2.253-5.507.918A.5.5 0 0 1 0 12v-1.382a1.5 1.5 0 0 1 .83-1.342L6 6.691V3c0-.568.14-1.271.428-1.849Z"/>
  </svg>
);

const ShipIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 16 16">
    <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8-6.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13Z"/>
    <path d="M6.354 7.146a.5.5 0 1 0-.708.708l8 8a.5.5 0 0 0 .708-.708l-8-8Z"/>
    <path d="M6.707 10.293a.5.5 0 0 0-.707.707l.527.527a.5.5 0 0 0 .707-.707l-.527-.527Zm4.583.293a.5.5 0 0 0-.707-.707l-.388.388a.5.5 0 0 0 .707.707l.388-.388Z"/>
  </svg>
);

const TruckIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 16 16">
    <path d="M0 3.5A1.5 1.5 0 0 1 1.5 2h9A1.5 1.5 0 0 1 12 3.5V5h1.02a1.5 1.5 0 0 1 1.17.563l1.481 1.85a1.5 1.5 0 0 1 .329.938V10.5a1.5 1.5 0 0 1-1.5 1.5H14a2 2 0 1 1-4 0H5a2 2 0 1 1-3.998-.085A1.5 1.5 0 0 1 0 10.5v-7zm1.294 7.456A1.999 1.999 0 0 1 4.732 11h5.536a2.01 2.01 0 0 1 .732-.732V3.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .294.456zM12 10a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm-8 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm8 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
  </svg>
);

const NetworkIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 16 16">
    <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm7.5-6.923c-.67.204-1.335.82-1.887 1.855-.143.268-.276.56-.395.872.705.157 1.472.257 2.282.287V1.077zM4.249 3.539c.142-.384.304-.744.481-1.078a6.7 6.7 0 0 1 .597-.933A7.01 7.01 0 0 0 3.051 3.05c.362.184.763.349 1.198.49zM3.509 7.5c.036-1.07.188-2.087.436-3.008a9.124 9.124 0 0 1-1.565-.667A6.964 6.964 0 0 0 1.018 7.5h2.49zm1.4-2.741a12.344 12.344 0 0 0-.4 2.741H7.5V5.091c-.91-.03-1.783-.145-2.591-.332zM8.5 5.09V7.5h2.99a12.342 12.342 0 0 0-.399-2.741c-.808.187-1.681.301-2.591.332zM4.51 8.5c.035.987.176 1.914.399 2.741A13.612 13.612 0 0 1 7.5 10.91V8.5H4.51zm3.99 0v2.409c.91.03 1.783.145 2.591.332.223-.827.364-1.754.4-2.741H8.5zm-3.282 3.696c.12.312.252.604.395.872.552 1.035 1.218 1.65 1.887 1.855V11.91c-.81.03-1.577.13-2.282.287zm.11 2.276a6.696 6.696 0 0 1-.598-.933 8.853 8.853 0 0 1-.481-1.079 8.38 8.38 0 0 0-1.198.49 7.01 7.01 0 0 0 2.276 1.522zm-1.383-2.964A13.36 13.36 0 0 1 3.508 8.5h-2.49a6.963 6.963 0 0 0 1.362 3.675c.47-.258.995-.482 1.565-.667zm6.728 2.964a7.009 7.009 0 0 0 2.275-1.521 8.376 8.376 0 0 0-1.197-.49 8.853 8.853 0 0 1-.481 1.078 6.688 6.688 0 0 1-.597.933zM8.5 11.909v3.014c.67-.204 1.335-.82 1.887-1.855.143-.268.276-.56.395-.872A12.63 12.63 0 0 0 8.5 11.91zm3.555-.401c.57.185 1.095.409 1.565.667A6.963 6.963 0 0 0 14.982 8.5h-2.49a13.36 13.36 0 0 1-.437 3.008zM14.982 7.5a6.963 6.963 0 0 0-1.362-3.675c-.47.258-.995.482-1.565.667.248.92.4 1.938.437 3.008h2.49zM11.27 2.461c.177.334.339.694.482 1.078a8.368 8.368 0 0 0 1.196-.49 7.01 7.01 0 0 0-2.275-1.52c.218.283.418.597.597.932zm-.488 1.343a7.765 7.765 0 0 0-.395-.872C9.835 1.897 9.17 1.282 8.5 1.077V4.09c.81-.03 1.577-.13 2.282-.287z"/>
  </svg>
);

const InfoCards = ({ isVisible }) => {
  return (
    <div className={`info-cards-container ${isVisible ? 'visible' : 'hidden'}`}>
      <h2 className="info-cards-title">Track Your Shipment Globally</h2>
      <p className="info-cards-subtitle">Our platform supports various tracking number formats from major carriers worldwide</p>
      
      <div className="info-cards-grid">
        <div className="info-card">
          <div className="info-card-icon air">
            <PlaneIcon />
          </div>
          <h3>Air Freight</h3>
          <p>Track by Master Airway Bill (MAWB) or House Airway Bill (HAWB) number</p>
          <div className="info-card-example">
            <span className="example-label">Example:</span>
            <span className="example-value">020-12345675</span>
          </div>
        </div>
        
        <div className="info-card">
          <div className="info-card-icon sea">
            <ShipIcon />
          </div>
          <h3>Ocean Freight</h3>
          <p>Track by Bill of Lading (B/L) or Booking Reference number</p>
          <div className="info-card-example">
            <span className="example-label">Example:</span>
            <span className="example-value">1234567890</span>
          </div>
        </div>
        
        <div className="info-card">
          <div className="info-card-icon road">
            <TruckIcon />
          </div>
          <h3>Road Freight</h3>
          <p>Track by Consignment Number or Reference ID for ground transportation</p>
          <div className="info-card-example">
            <span className="example-label">Example:</span>
            <span className="example-value">123456789</span>
          </div>
        </div>
        
        <div className="info-card network-card">
          <div className="info-card-icon network">
            <NetworkIcon />
          </div>
          <h3>Global Carrier Network</h3>
          <p>Access to over 1,540 carriers worldwide in a single search</p>
          <ul className="carrier-list">
            <li>240+ Airlines</li>
            <li>120+ Shipping Lines</li>
            <li>300+ Express Couriers</li>
          </ul>
        </div>
      </div>
      
      <div className="info-cards-footer">
        <p>Simply enter your tracking number to begin</p>
      </div>
    </div>
  );
};

export default InfoCards;
